import React from "react";
import { Container } from "./styles";
import { useAuth } from "../../../hooks/AuthContext";
import { useNavigate } from "react-router-dom";
import { MdLogout, MdPersonOutline } from "react-icons/md";
import userPhoto from "../../../images/user.png";

export default function PerfilAdmin() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut();
    navigate("/admin/login");
  };

  return (
    <Container>
      <h1>Meu Perfil</h1>

      <div className="profile-content">
        {/* Card de Foto */}
        <div className="photo-card">
          <div className="photo-container">
            <img
              src={user.photo ? user?.photo_url : userPhoto}
              alt="Foto de Perfil"
            />
          </div>
          <div style={{ textAlign: "center" }}>
            <h3>{user?.name}</h3>
            <p>Perfil de {user?.type || "Administrador"}</p>
          </div>
        </div>

        {/* Card de Informações */}
        <div className="info-card">
          <div className="section-title">
            <MdPersonOutline size={20} />
            Informações Pessoais
          </div>

          <div className="info-grid">
            <div className="info-item">
              <label>Nome Completo</label>
              <span>{user?.name}</span>
            </div>
            <div className="info-item">
              <label>E-mail Corporativo</label>
              <span>{user?.email}</span>
            </div>
            <div className="info-item">
              <label>Telefone / WhatsApp</label>
              <span>{user?.phone_number || "Não informado"}</span>
            </div>
            <div className="info-item">
              <label>CPF</label>
              <span>{user?.cpf || "Não informado"}</span>
            </div>
            <div className="info-item">
              <label>CNPJ</label>
              <span>{user?.cnpj || "Não informado"}</span>
            </div>
            <div className="info-item">
              <label>Cidade / Estado</label>
              <span>
                {user?.city && user?.state
                  ? `${user.city} - ${user.state}`
                  : "Não informado"}
              </span>
            </div>
          </div>

          <div className="actions">
            <button className="logout-btn" onClick={handleSignOut}>
              <MdLogout size={18} /> Sair da Conta
            </button>
          </div>
        </div>
      </div>
    </Container>
  );
}
